import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_7159d61d from 'nuxt_plugin_plugin_7159d61d' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_0065e177 from 'nuxt_plugin_sentryserver_0065e177' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_caa72022 from 'nuxt_plugin_sentryclient_caa72022' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_65d3434a from 'nuxt_plugin_cookieuniversalnuxt_65d3434a' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_image_7c34fca4 from 'nuxt_plugin_image_7c34fca4' // Source: ./image.js (mode: 'all')
import nuxt_plugin_gtm_83e2476e from 'nuxt_plugin_gtm_83e2476e' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_pluginutils_417cf430 from 'nuxt_plugin_pluginutils_417cf430' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_6a0f8d9a from 'nuxt_plugin_pluginrouting_6a0f8d9a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_26cf771c from 'nuxt_plugin_pluginmain_26cf771c' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_5242f69a from 'nuxt_plugin_axios_5242f69a' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_deviceplugin_228bb93e from 'nuxt_plugin_deviceplugin_228bb93e' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_gsapModule_1cee007e from 'nuxt_plugin_gsapModule_1cee007e' // Source: ./gsapModule.js (mode: 'all')
import nuxt_plugin_vuelidate_4be431c8 from 'nuxt_plugin_vuelidate_4be431c8' // Source: ../plugins/vuelidate.js (mode: 'all')
import nuxt_plugin_vmask_3c04b27e from 'nuxt_plugin_vmask_3c04b27e' // Source: ../plugins/v-mask.js (mode: 'all')
import nuxt_plugin_vueselect_af0f7784 from 'nuxt_plugin_vueselect_af0f7784' // Source: ../plugins/vue-select.js (mode: 'all')
import nuxt_plugin_vuejsmodal_a01fef9e from 'nuxt_plugin_vuejsmodal_a01fef9e' // Source: ../plugins/vue-js-modal.js (mode: 'all')
import nuxt_plugin_vuetelinput_3f647bbc from 'nuxt_plugin_vuetelinput_3f647bbc' // Source: ../plugins/vue-tel-input.js (mode: 'all')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_swiper_68e7f06e from 'nuxt_plugin_swiper_68e7f06e' // Source: ../plugins/swiper.js (mode: 'client')
import nuxt_plugin_ssr_3c8dadee from 'nuxt_plugin_ssr_3c8dadee' // Source: ../plugins/vue-notifications/ssr.js (mode: 'all')
import nuxt_plugin_client_10db2568 from 'nuxt_plugin_client_10db2568' // Source: ../plugins/vue-notifications/client.js (mode: 'client')
import nuxt_plugin_distpluginnuxt2590403d0_103d8206 from 'nuxt_plugin_distpluginnuxt2590403d0_103d8206' // Source: ./dist.plugin-nuxt2.590403d0.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"facebook-domain-verification","content":"rl70sbx3cw6a2tjwyge0ikk7m4uvl1"}],"link":[{"hid":"shortcut icon","rel":"shortcut icon","type":"image\u002Fpng","sizes":"192x192","href":"\u002Ffavicons\u002Flogo-192-192.png"},{"hid":"apple-touch-icon","rel":"apple-touch-icon","type":"image\u002Fpng","sizes":"180x180","href":"\u002Ffavicons\u002Flogo-180-180.png"},{"hid":"icon","rel":"icon","type":"image\u002Fpng","sizes":"512x512","href":"\u002Ffavicons\u002Flogo-512-512.png"},{"hid":"icon","rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicons\u002Flogo-32-32.png"},{"hid":"icon","rel":"icon","type":"image\u002Fpng","sizes":"512x512","href":"\u002Ffavicons\u002Flogo-16-16.png"},{"hid":"icon","rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicons\u002Ffavicon.ico"}],"script":[{"hid":"esputnik","src":"\u002Fscripts\u002Fesputnik.js"},{"hid":"GA4","src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-96M43GYS46","async":true},{"hid":"GA4_init","src":"\u002Fscripts\u002FGA4.js"},{"hid":"pixel","src":"\u002Fscripts\u002Fpixel.js"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-PMNTX9K')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"children":"\u003Cimg height=\"1\" width=\"1\" style=\"display:none\"\n          src=\"https:\u002F\u002Fwww.facebook.com\u002Ftr?id=812446406857820&ev=PageView&noscript=1\"\n        \u002F\u003E","body":true},{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-PMNTX9K&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"style":[],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7159d61d === 'function') {
    await nuxt_plugin_plugin_7159d61d(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_0065e177 === 'function') {
    await nuxt_plugin_sentryserver_0065e177(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_caa72022 === 'function') {
    await nuxt_plugin_sentryclient_caa72022(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_65d3434a === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_65d3434a(app.context, inject)
  }

  if (typeof nuxt_plugin_image_7c34fca4 === 'function') {
    await nuxt_plugin_image_7c34fca4(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_83e2476e === 'function') {
    await nuxt_plugin_gtm_83e2476e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_417cf430 === 'function') {
    await nuxt_plugin_pluginutils_417cf430(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_6a0f8d9a === 'function') {
    await nuxt_plugin_pluginrouting_6a0f8d9a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_26cf771c === 'function') {
    await nuxt_plugin_pluginmain_26cf771c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5242f69a === 'function') {
    await nuxt_plugin_axios_5242f69a(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_228bb93e === 'function') {
    await nuxt_plugin_deviceplugin_228bb93e(app.context, inject)
  }

  if (typeof nuxt_plugin_gsapModule_1cee007e === 'function') {
    await nuxt_plugin_gsapModule_1cee007e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4be431c8 === 'function') {
    await nuxt_plugin_vuelidate_4be431c8(app.context, inject)
  }

  if (typeof nuxt_plugin_vmask_3c04b27e === 'function') {
    await nuxt_plugin_vmask_3c04b27e(app.context, inject)
  }

  if (typeof nuxt_plugin_vueselect_af0f7784 === 'function') {
    await nuxt_plugin_vueselect_af0f7784(app.context, inject)
  }

  if (typeof nuxt_plugin_vuejsmodal_a01fef9e === 'function') {
    await nuxt_plugin_vuejsmodal_a01fef9e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetelinput_3f647bbc === 'function') {
    await nuxt_plugin_vuetelinput_3f647bbc(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiper_68e7f06e === 'function') {
    await nuxt_plugin_swiper_68e7f06e(app.context, inject)
  }

  if (typeof nuxt_plugin_ssr_3c8dadee === 'function') {
    await nuxt_plugin_ssr_3c8dadee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_client_10db2568 === 'function') {
    await nuxt_plugin_client_10db2568(app.context, inject)
  }

  if (typeof nuxt_plugin_distpluginnuxt2590403d0_103d8206 === 'function') {
    await nuxt_plugin_distpluginnuxt2590403d0_103d8206(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
